import React, {useMemo} from 'react';
import {useShallow} from 'zustand/react/shallow';

import {useQuestionTranslationStore} from '../../shared/TranslationSection/TranslationStore';
import PassageCorrectionExplanation from '../legacy/PassageCorrectionExplanation.react';

const PassageCorrectionExplanationWrapper = (props: any) => {
  const {showTranslations, translationInfo} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question,
      translationInfo: state.translatedQuestionInfo
    }))
  );

  const questionText = useMemo(() => {
    return translationInfo?.uncorrected_text;
  }, [translationInfo]);

  const solutionText = useMemo(() => {
    return translationInfo?.solution_text;
  }, [translationInfo]);

  return (
    <PassageCorrectionExplanation
      {...props}
      showTranslation={showTranslations}
      translatedUncorrectedText={questionText}
      translatedSolutionText={solutionText}
    />
  );
};

export default PassageCorrectionExplanationWrapper;
